if (window.innerWidth > 768) {
  gsap.registerPlugin(ScrollTrigger);

  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: ".section_slipper",
      start: "top bottom-=300",
      end: "bottom top+=100",     // Khi phần tử hết khỏi viewport
      scrub: true,
      pin: ".animation-wrapper",
      pinSpacing: false      // Để tránh tạo khoảng trống khi pin
    }
  });

  // Không thay đổi vị trí y cho layer1
  // gsap.set("#layer1", { y: "0px", opacity: 1 });  // có thể bỏ dòng này nếu có

  gsap.set("#layer2", { y: "-55px", opacity: 1 });
  gsap.set("#layer3", { y: "-120px", opacity: 1 });
  gsap.set("#layer4", { y: "-187px", opacity: 1 });
  gsap.set("#layer5", { y: "-256px", opacity: 1 });

  timeline
    // Không animate vị trí y của layer1
    //.to("#layer1", { y: "0px", opacity: 1 }, 0)  // bỏ dòng này nếu có
    
    .to("#layer2", { y: "30px", opacity: 1 }, 0.1)
    .to("#layer3", { y: "60px", opacity: 1 }, 0.1)
    .to("#layer4", { y: "90px", opacity: 1 }, 0.1)
    .to("#layer5", { y: "120px", opacity: 1 }, 0.1)
    // Vẫn có thể giữ animation opacity text cho layer1
    .to("#layer1 .layer-text", { opacity: 1 }, 0.15)
    .to("#layer2 .layer-text", { opacity: 1 }, 0.15)
    .to("#layer3 .layer-text", { opacity: 1 }, 0.15)
    .to("#layer4 .layer-text", { opacity: 1 }, 0.15);
} else {
    gsap.registerPlugin(ScrollTrigger);

  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: ".section_slipper",
      start: "top bottom-=400",
      end: "bottom top+=700",
      scrub: true,
      pin: ".animation-wrapper",
      pinSpacing: false,
    }
  });
  
  // Set vị trí ban đầu cho các layer
  gsap.set("#layer2", { y: "-117px", opacity: 1 });
  gsap.set("#layer3", { y: "-245px", opacity: 1 });
  gsap.set("#layer4", { y: "-375px", opacity: 1 });
  gsap.set("#layer5", { y: "-499px", opacity: 1 });
  
  // Thêm offset cho từng layer để có khoảng cách mượt mà hơn
  timeline
    .to("#layer2", { y: "0px", opacity: 1 }, 0.5)
    .to("#layer3", { y: "0px", opacity: 1 }, 0.5)  // cách 0.3 trong timeline
    .to("#layer4", { y: "0px", opacity: 1 }, 0.5)
    .to("#layer5", { y: "0px", opacity: 1 }, 0.5)
  
    .to("#layer1 .layer-text", { opacity: 1 }, 0.9)
    .to("#layer2 .layer-text", { opacity: 1 }, 0.9)
    .to("#layer3 .layer-text", { opacity: 1 }, 0.9)
    .to("#layer4 .layer-text", { opacity: 1 }, 0.9);

}
